<template>
  <div :id="componentId" class="sp1-review-gala" :style="sectionStyle">
    <div class="gala-tabs flex-row">
      <div
        v-for="(tab, idx) in tabs"
        :key="idx"
        class="gala-tab flex-col"
        :class="{ active: idx === activeIndex }"
        :style="tabStyle(idx)"
        @click="activeIndex = idx"
      >
        <span class="gala-tab-text" :style="tabTextStyle(idx)">{{ tab.title }}</span>
      </div>
    </div>
    <div class="gala-image-wrapper flex-col" :style="wrapperStyle">
      <img
        class="gala-image"
        referrerpolicy="no-referrer"
        :src="tabs[activeIndex].imageUrl"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewGala',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_12'
    }
  },
  data() {
    return {
       activeIndex: 0,
      backgroundColor: 'rgba(255, 255, 255, 1)',
      labelFontColor: 'rgba(102, 102, 102, 1)',
      labelBackgroundColor: 'rgba(243, 246, 243, 1)',
      tabs: [
        {
          title: '2025区域农业品牌年度案例',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG894172f6449fc8b04155bf0a17efac53.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        },
        {
          title: '2025区域农业公用品牌价值评价',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        },
        {
          title: '2025中国区域农业形象品牌影响力指数',
          imageUrl: require('../assets/img/review_banner.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        },
        {
          title: '2025中国区域农业产业品牌影响力指数',
          imageUrl: require('../assets/img/FigmaDDSSlicePNG5adf7b382decbc2b0222481272ddf408.png'),
          selectedFontColor: 'rgba(255, 255, 255, 1)',
          selectedLabelBgImage: require('../assets/img/FigmaDDSSlicePNG449112c162ae2f8b7425c584c9a3c44e.png'),
          selectedMainBgImage: require('../assets/img/FigmaDDSSlicePNG679db7b67dfab09bcc9193bf30e1242b.png')
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
         padding: '20px 300px',
        boxSizing: 'border-box',
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    },
    wrapperStyle() {
      const tab = this.tabs[this.activeIndex];
      return {
        backgroundImage: tab && tab.selectedMainBgImage ? `url(${tab.selectedMainBgImage})` : 'none',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      };
    }
  },
  methods: {
    tabStyle(idx) {
      const tab = this.tabs[idx];
      if (idx === this.activeIndex && tab && tab.selectedLabelBgImage) {
        return {
          backgroundImage: `url(${tab.selectedLabelBgImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%',
          backgroundColor: 'transparent'
        };
      }
      return {
        backgroundColor: this.labelBackgroundColor
      };
    },
    tabTextStyle(idx) {
      const tab = this.tabs[idx];
      if (idx === this.activeIndex && tab && tab.selectedFontColor) {
        return { color: tab.selectedFontColor };
      }
      return { color: this.labelFontColor };
    }
  }
};
</script>

<style scoped>
.sp1-review-gala {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.gala-tabs {
  width: 1400px;
  height: 112px;
}

.gala-tab {
  width: 322px;
  height: 112px;
  margin-left: 37px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gala-tab:first-child {
  margin-left: 0;
}

.gala-tab-text {
  width: 260px;
  font-size: 26px;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: center;
  white-space: pre-line;
  line-height: 34px;
}

.gala-image-wrapper {
  width: 1400px;
  height: 793px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gala-image {
  width: 1329px;
  height: 737px;
  object-fit: cover;
}
</style>
